<div class="container">
  <dp-svg [src]="data.icon" w="30"></dp-svg>
  <div class="snackbar-text">{{data.message}}</div>
</div>
